import { render, staticRenderFns } from "./mealrecord.vue?vue&type=template&id=09c86984&scoped=true"
import script from "./mealrecord.vue?vue&type=script&lang=js"
export * from "./mealrecord.vue?vue&type=script&lang=js"
import style0 from "./mealrecord.vue?vue&type=style&index=0&id=09c86984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c86984",
  null
  
)

export default component.exports